import { Component, Input, OnInit } from '@angular/core';
import { RenaultLastUpdateDTO } from '../../../models/last-update-dto';
import { heightContentAnimation } from 'src/app/animations';

@Component({
  selector: 'app-last-update',
  templateUrl: './last-update.component.html',
  styleUrls: ['./last-update.component.scss'],
  animations: [heightContentAnimation]
})
export class LastUpdateComponent implements OnInit {

  @Input() model: RenaultLastUpdateDTO;

  constructor() { }

  ngOnInit(): void { }

}
